// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hoopa_unbound: PokeData = {
  "id": 10086,
  "name": "hoopa-unbound",
  "height": 65,
  "weight": 4900,
  "base_experience": 306,
  "types": [
    PokeType.PSYCHIC,
    PokeType.DARK
  ],
  "api_moves": [
    "psybeam",
    "confusion",
    "psychic",
    "light-screen",
    "destiny-bond",
    "trick",
    "magic-coat",
    "knock-off",
    "skill-swap",
    "astonish",
    "dark-pulse",
    "trick-room",
    "guard-split",
    "power-split",
    "wonder-room",
    "ally-switch",
    "hyperspace-fury"
  ],
  "moves": [
    "psychic",
    "dark-pulse",
    "psychic-fangs",
    "dark-bargain",
    "future-sight",
    "psywave",
    "psy-pulse",
    "prismatic-cage",
    "crunch",
    "flatter",
    "synchronize",
    "night-slash",
    "phantom-force"
  ],
  "evolution_chain": {
    "id": 372,
    "item": null,
    "species": [
      {
        "name": "hoopa",
        "order": 720,
        "types": [
          PokeType.PSYCHIC,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 104,
    "speed": 95,
    "ability_power": 201
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
